<template>
  <div style="padding-top: 40px">
    <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
      Naprava ni priklopljena v omrežje.
      Prosimo, preverite ustreznost priklopa naprave ali nas pokličite na 064 064 064.
    </div>
    <div v-else>
      <div>
        <p class="navadno-besedilo">
          Posredovanje vrat omogoča oddaljenim napravam (računalniki, videokamere, strežniki, druge
          omrežne naprave), da se povežejo z določenim računalnikom <br v-if="prikazTabele === '1'"/>
          ali storitvijo znotraj zasebnega lokalnega omrežja (LAN).
        </p>
      </div>
      <div v-if="dolzinaSeznamaPortForward !== 0" style="padding-top: 20px">
        <div v-show="prikazTabele === '1'">
          <el-table :data="seznamPodatkovPortForward" empty-text="Ni dodanih pravil" v-loading="loadingPFPravila">
            <el-table-column prop="Decscription"
                             label="Opis pravila">
            </el-table-column>
            <el-table-column prop="InternalClient"
                             label="IP naslov">
            </el-table-column>
            <el-table-column prop="Protocol"
                             label="Protokol">
            </el-table-column>
            <el-table-column prop="externalPortRange"
                             label="Zunanji port">
            </el-table-column>
            <el-table-column prop="internalPortRange"
                             label="Notranji port">
            </el-table-column>
            <el-table-column align="right" width="50px">
              <template slot-scope="scope">
                <div>
                  <el-tooltip class="item" effect="dark"
                              content="Odstrani pravilo."
                              placement="right">
                    <a @click="OdstraniPortForwardPravilo(scope.row.InstanceNumber)"
                       style="cursor: pointer">
                      <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                    </a>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="prikazTabele === '0'">
          <el-table
            :data="seznamPodatkovPortForward"
            v-loading="loadingPFPravila"
            :expand-row-keys="expandRowKeys"
            empty-text="Ni dodanih pravil"
            :row-key="row => row.Decscription"
            @expand-change="IzbiraVrsticeZaPregledOpravila">
            <el-table-column label="Opis pravila" prop="Decscription">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding: 20px 0 20px 0">
                  <el-form label-width="120px" :label-position="formaOrientacija">
                    <el-form-item label="Opis pravila:" class="tabela-odstrani-pravlo">
                      {{ scope.row.Decscription }}
                    </el-form-item>
                    <el-form-item label="IP naslov:" class="tabela-odstrani-pravlo">
                      {{ scope.row.InternalClient }}
                    </el-form-item>
                    <el-form-item label="Protokol:" class="tabela-odstrani-pravlo">
                      {{ scope.row.Protocol }}
                    </el-form-item>
                    <el-form-item label="Zunanji port:" class="tabela-odstrani-pravlo">
                      {{ scope.row.externalPortRange }}
                    </el-form-item>
                    <el-form-item label="Notranji port:" class="tabela-odstrani-pravlo">
                      {{ scope.row.internalPortRange }}
                    </el-form-item>
                  </el-form>
                  <a class="odstrani-opravilo" @click="OdstraniPortForwardPravilo(scope.row.InstanceNumber)"
                     style="cursor: pointer">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                    <span class="krepko crna odmik-levo">
                      ODSTRANI PRAVILO
                    </span>
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-center" style="cursor: pointer;">
          <br/>
          <el-pagination
            @current-change="PrikaziStran"
            :page-size="4"
            layout="prev, pager, next"
            :hide-on-single-page="true"
            :total="dolzinaSeznamaPortForward"
            small>
          </el-pagination>
        </div>
        <div style="padding-top: 30px">
          <el-button @click="OsveziPravila(true)" class="gumb-potrdi">
            OSVEŽI ZAPIS
          </el-button>
        </div>
      </div>
      <div>
        <InfoKomponentaMreznaOprema/>
      </div>
      <div style="padding-top: 40px">
        <hr class="hr-stil">
      </div>
      <div style="padding-top: 40px">
        <div>
          <p class="open-sans-20pt">
            Novo pravilo
          </p>
        </div>
        <div style="padding-top: 40px">
          <el-form label-width="200px" :label-position="formaOrientacija" v-if="idIzbranaOprema.length">
            <el-form-item label="Opis pravila" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069Description" class="velikost-input">
              </el-input>
            </el-form-item>
            <el-form-item label="IP naslov za promet" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069Ip" class="velikost-input">
              </el-input>
            </el-form-item>
            <el-form-item label="Protokol" class="forma-dodaj-novo-pravilo">
              <el-select v-model="dodajTr069Protocol" class="velikost-input">
                <el-option v-for="(data,index) in seznamProtokoli" :key="data" :value="data" :label="data.izbiraIzpis"/>
              </el-select>
            </el-form-item>
            <el-form-item label="Začetni zunanji port" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069ExterniPortStart" class="velikost-input">
              </el-input>
            </el-form-item>
            <el-form-item label="Začetni notranji port" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069InterniPortStart" class="velikost-input">
              </el-input>
            </el-form-item>
            <el-form-item label="Končni zunanji port" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069ExterniPortEnd" class="velikost-input">
              </el-input>
            </el-form-item>
            <el-form-item label="Končni notranji port" class="forma-dodaj-novo-pravilo">
              <el-input placeholder="" v-model="dodajTr069InterniPortEnd" class="velikost-input">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-top: 40px">
          <el-button type="primary" @click="DodajPortForwardPravilo" class="gumb-potrdi">
            DODAJ NOVO PRAVILO
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  Input,
  Button,
  Form,
  FormItem,
  Collapse,
  CollapseItem,
  Select,
  Option,
  MessageBox,
  Tooltip,
  Pagination
} from 'element-ui'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import InfoKomponentaMreznaOprema from './InfoKomponentaMreznaOprema'

Vue.use(Form)
Vue.use(FormItem)
export default {
  name: 'portforward',
  mixins: [PrikazVsebine, SirinaOkna],
  props: {
    idIzbranaOprema: {},
    povezanoVOmrezje: false
  },
  emits: ['successNotification'],
  data () {
    return {
      titlePf: 'PortForward',
      clientAgent: null,
      dodajTr069Description: '',
      dodajTr069Ip: '',
      dodajTr069Protocol: '',
      dodajTr069ExterniPortStart: '',
      dodajTr069InterniPortStart: '',
      dodajTr069ExterniPortEnd: '',
      dodajTr069InterniPortEnd: '',
      seznamProtokoli: ['TCP', 'UDP', 'TCP/UDP'],
      loadingPFPravila: false,
      seznamPortForward: [],
      mejnaSirina: 600,
      mejnaSirinaTabela: 1407,
      formaOrientacija: 'left',
      prikazTabele: '1',
      seznamPodatkovPortForward: [],
      dolzinaSeznamaPortForward: null,
      expandRowKeys: []
    }
  },
  components: {
    InfoKomponentaMreznaOprema,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Pagination.name]: Pagination
  },
  watch: {
    orientacija: function (val) {
      this.formaOrientacija = val
    },
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    },
    idIzbranaOprema: function () {
      if (this.idIzbranaOprema !== null) {
        this.GetSeznamPortForwardPravil()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetSeznamPortForwardPravil()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaPregledOpravila (row) {
      const id = row.Decscription
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetSeznamPortForwardPravil () {
      if (this.povezanoVOmrezje) {
        this.loadingPFPravila = true
        if (this.idIzbranaOprema.length) {
          let param = ['idOprema=' + this.idIzbranaOprema]
          this.clientAgent.postWsRequest(
            this,
            'tr069/portForwarding/info',
            param,
            null,
            'SetSeznamPravil',
            'ErrSeznamPravil')
        }
      }
    },
    SetSeznamPravil (podatki) {
      this.seznamPortForward = []
      let rulesList = []
      if (podatki.data !== null) {
        Object.keys(podatki.data.Rules).forEach(function (key, index) {
          rulesList.push(podatki.data.Rules[key])
        })
        this.seznamPortForward = rulesList
        for (let i = 0; i < this.seznamPortForward.length; i++) {
          let pravilo = this.seznamPortForward[i]
          this.seznamPortForward[i].externalPortRange = pravilo.ExternalPortStart + '-' + pravilo.ExternalPortEnd
          this.seznamPortForward[i].internalPortRange = pravilo.InternalPortStart + '-' + pravilo.InternalPortEnd
        }
        if (typeof this.seznamPortForward !== 'undefined') {
          let tmpArray = []
          this.dolzinaSeznamaPortForward = this.seznamPortForward.length
          const chunk = 4
          for (let i = 0; i < this.dolzinaSeznamaPortForward; i += chunk) {
            tmpArray.push(this.seznamPortForward.slice(i, i + chunk))
          }
          this.seznamPortForward = tmpArray
          this.PrikaziStran(1)
        }
      }
      this.loadingPFPravila = false
    },
    ErrSeznamPravil () {
      this.loadingPFPravila = false
    },
    PrikaziStran (stran) {
      if (typeof this.seznamPortForward[stran - 1] !== 'undefined') {
        this.seznamPodatkovPortForward = this.seznamPortForward[stran - 1]
      } else {
        this.seznamPodatkovPortForward = []
      }
      this.loadingPFPravila = false
    },
    DodajPortForwardPravilo () {
      if (this.idIzbranaOprema.length) {
        if (this.dodajTr069Description === '' ||
            this.dodajTr069Ip === '' ||
            this.dodajTr069Protocol === '' ||
            this.dodajTr069ExterniPortStart === '' ||
            this.dodajTr069InterniPortStart === '' ||
            this.dodajTr069ExterniPortEnd === '' ||
            this.dodajTr069InterniPortEnd === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Prosimo, izpolnite vse zahtevane podatke za dodajanje pravil.'
          this.ShowWarningMessage(paramObvestilo)
        } else {
          let param = ['idOprema=' + this.idIzbranaOprema]
          param.push('description=' + encodeURI(this.dodajTr069Description))
          param.push('ip=' + encodeURI(this.dodajTr069Ip))
          param.push('protocol=' + this.dodajTr069Protocol)
          param.push('externiPortStart=' + parseInt(this.dodajTr069ExterniPortStart))
          param.push('interniPortStart=' + parseInt(this.dodajTr069InterniPortStart))
          param.push('externiPortEnd=' + parseInt(this.dodajTr069ExterniPortEnd))
          param.push('interniPortEnd=' + parseInt(this.dodajTr069InterniPortEnd))

          this.clientAgent.postWsRequest(
            this,
            'tr069/portForwarding/add',
            param,
            null,
            'ShowSuccessDodanoPravilo',
            'ShowErrorMsg')
        }
      }
    },
    OsveziPravila (showMessage = false) {
      if (this.dodajTr069Description === '' &&
          this.dodajTr069Ip === '' &&
          this.dodajTr069Protocol === '' &&
          this.dodajTr069ExterniPortStart === '' &&
          this.dodajTr069InterniPortStart === '' &&
          this.dodajTr069ExterniPortEnd === '' &&
          this.dodajTr069InterniPortEnd === '') {
        if (showMessage) {
          let paramObvestilo = {}
          paramObvestilo.message = 'V nastavitvah ni bilo opravljenih nobenih sprememb.'
          this.ShowWarningMessage(paramObvestilo)
        }
      } else {
        this.GetSeznamPortForwardPravil()
        this.ToggleAddForm()
        if (showMessage) {
          this.$emit('successNotification')
        }
      }
    },
    OdstraniPortForwardPravilo (ruleId) {
      MessageBox.confirm('Ali ste prepričani, da želite odstraniti port?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        let param = ['idOprema=' + this.idIzbranaOprema]
        param.push('ruleId=' + ruleId)
        this.clientAgent.postWsRequest(
          this,
          'tr069/portForwarding/delete',
          param,
          null,
          'ShowSuccessMsg',
          'ShowErrorMsg')
      }).catch((err) => {
        err = null
        this.ShowErrorMsg()
      })
    },
    ShowSuccessMsg () {
      this.OsveziPravila()
    },
    ShowSuccessDodanoPravilo () {
      this.ToggleAddForm()
      this.$emit('successNotification')
    },
    ShowErrorMsg (podatki) {
      this.OsveziPravila()
      this.ShowWarningMessage(podatki)
    },
    ToggleAddForm () {
      this.dodajTr069Description = ''
      this.dodajTr069Ip = ''
      this.dodajTr069Protocol = ''
      this.dodajTr069ExterniPortStart = ''
      this.dodajTr069InterniPortStart = ''
      this.dodajTr069ExterniPortEnd = ''
      this.dodajTr069InterniPortEnd = ''
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/portforward.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/Portforward.vue